import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import typographyStyle from '../../assets/jss/material-kit-react/components/typographyStyle';
function Info({ ...props }) {
    const { classes, children } = props;
    return (React.createElement("div", { className: classes.defaultFontStyle + ' ' + classes.infoText }, children));
}
Info.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
};
export default withStyles(typographyStyle)(Info);
//# sourceMappingURL=Info.js.map